import toastr from 'toastr';

const popupWrapper = document.querySelector( '.wcbt-sale-notice-wrapper' );
const { __ } = wp.i18n;

const wcbtSaleNoticePopup = () => {
	if ( ! popupWrapper ) {
		return;
	}

	const products = WCBT_SALE_NOTICE_OBJECT.product_info || [];

	if ( ! products ) {
		return;
	}

	//Random
	[ ...products ].map( ( product, index ) => {
		setTimeout(
			() => {
				showToastr( product );
			},
			5000 * ( index + 1 )
		);
	} );
};

const showToastr = ( item ) => {
	let positionClass;
	switch ( WCBT_SALE_NOTICE_OBJECT.position ) {
	case 'top_full_width':
		positionClass = 'toast-top-full-width';
		break;
	case 'bottom_full_width':
		positionClass = 'toast-bottom-full-width';
		break;
	case 'top_left':
		positionClass = 'toast-top-left';
		break;
	case 'top_right':
		positionClass = 'toast-top-right';
		break;
	case 'bottom_left':
		positionClass = 'toast-bottom-left';
		break;
	case 'bottom_right':
		positionClass = 'toast-bottom-right';
		break;
	default:
		positionClass = 'toast-bottom-left';
		break;
	}

	toastr.options = {
		escapeHtml: false,
		closeButton: WCBT_SALE_NOTICE_OBJECT.close_button === 'on',
		newestOnTop: false,
		progressBar: WCBT_SALE_NOTICE_OBJECT.progress_bar === 'on',
		positionClass, // position
		preventDuplicates: true,
		onclick: null,
		showDuration: WCBT_SALE_NOTICE_OBJECT.show_duration, // time appear
		hideDuration: WCBT_SALE_NOTICE_OBJECT.hide_duration, // time disappear
		timeOut: WCBT_SALE_NOTICE_OBJECT.timeout, // time when user not hover
		// extendedTimeOut: 5000, // time when user hover
		showMethod: WCBT_SALE_NOTICE_OBJECT.show_method,
		hideMethod: WCBT_SALE_NOTICE_OBJECT.hide_method,
	};

	let content = `
		<div class="product-notification">
			<div class="product-notification__wrapper"> 
				`;
	if ( item.thumbnail && WCBT_SALE_NOTICE_OBJECT.image_position === 'left' ) {
		content += `
			<a class="product-image" href="${ item.url }">
				<img src="${ item.thumbnail }" alt="${ item.title }" loading="lazy" width="40" height="70">
			</a>
		`;
	}
	content += `<div class="product-notification-content">
					<p style="color:${ WCBT_SALE_NOTICE_OBJECT.text_color };">${ item.message }</p>
					<a style="color:${ WCBT_SALE_NOTICE_OBJECT.text_color };" class="product-name" href="${ item.url }">${ item.title }</a>
				</div>`;

	if ( item.thumbnail && WCBT_SALE_NOTICE_OBJECT.image_position === 'right' ) {
		content += `
			<a class="product-image" href="${ item.url }">
				<img src="${ item.thumbnail }" alt="${ item.title }" loading="lazy" width="40" height="70">
			</a>
		`;
	}

	content += `<div class="info-ago">
					<span class="time-text" style="color:${ WCBT_SALE_NOTICE_OBJECT.text_color };">${ item.time_ago }` + __( ' minutes ago', 'wcbt' ) + `</span>
				</div>
			</div>
		</div>
	`;

	toastr.success( content );
};

export default wcbtSaleNoticePopup;

